
import MemberLayout from '../layouts/member/Layout';
import PublicLayout from '../layouts/public/Layout';

import PasswordPage from '../pages/member/account/PasswordPage';
import ProfilePage from '../pages/member/account/ProfilePage';
import LoginPage from '../pages/member/access/LoginPage';
import SignupPage from '../pages/member/SignupPage';
import DashboardPage from '../pages/member/dashboard/DashboardPage';

// import ProductsPage from '../pages/member/products/ProductsPage';
// import ProductViewPage from '../pages/member/products/ProductViewPage';

export default function routes() {

    return [
        {
            path: '/member',
            element: <PublicLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: 'login', element: <LoginPage /> },
                { path: 'signup', element: <SignupPage /> },
            ],
        },
        {
            path: '/member',
            element: <MemberLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: '', element: <DashboardPage /> },

                { path: 'dashboard', element: <DashboardPage /> },
                { path: 'profile', element: <ProfilePage /> },
                { path: 'password', element: <PasswordPage /> },

                // { path: 'products', element: <ProductsPage /> },
                // { path: 'product/view/:id', element: <ProductViewPage /> },

            ],
        }
    ]
}